import clsx from "clsx"

import { LabelProps } from "@atoms/Label/Label.types"
import { Label } from "@atoms/index"

import { BaseInputHelpText } from "@molecules/Form/inputs/Input/InputHelpText/InputHelpText"
import { AlertBanner } from "@molecules/index"

import styles from "./FormModule.module.scss"
import { FormModuleProps } from "./FormModule.types"

export default function FormModule(props: FormModuleProps) {
    const { label, supportText, banner, children, className, isError, errorMessage, ...rest } = props

    const labelIsString = typeof label === "string"

    const getLabelProps = (): Omit<LabelProps, "size"> => {
        if (labelIsString) {
            return {
                label,
                state: isError ? "error" : "default",
            }
        } else if (label) {
            return {
                ...label,
                state: isError ? "error" : label.state,
            }
        } else {
            return { label: "", state: "default" }
        }
    }

    return (
        <div className={clsx(styles.base, className)} {...rest}>
            <div className={styles.labelAndSupportText}>
                {label ? <Label {...getLabelProps()} /> : null}
                {supportText ? <div className={styles.supportText}>{supportText}</div> : null}
            </div>
            {banner && <AlertBanner {...banner} />}
            {children}
            {isError === true && typeof errorMessage === "string" && (
                <BaseInputHelpText status="error" message={errorMessage} />
            )}
        </div>
    )
}
